var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEzInfrastructures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 14.44v40.42H55v-18.2a17.61 17.61 0 10-35.21 0c0 .83.19 19.2.19 19.2H9.2V14.44A6.46 6.46 0 0115.64 8h43.92A6.46 6.46 0 0166 14.44zM40.74 30L51 70h4.13L44.87 30h-4.13zM36 70h3v-7h-3v7zm0-13h3v-7h-3v7zm0-13h3v-7h-3v7zM22.13 60.82L19.89 70H24l9.8-40h-4.12l-7.55 30.82z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/EZ_Infrastructures.361303dd.svg";
export { SvgEzInfrastructures as ReactComponent };